var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    uploader: true,
    uploading: _vm.dragging
  },on:{"dragenter":_vm.onDragEnter,"dragover":_vm.onDragOver,"dragend":_vm.onDragEnd,"drop":_vm.onDrop,"dragleave":_vm.onDragLeave}},[(_vm.dragging)?_c('div',{staticClass:"overlay"},[_c('span',{staticClass:"overlay__text"},[_vm._v("Drop to Upload")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }